<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { marked } from 'marked'

const isDrawing = ref(false)
const canvasRef = ref(null)
const ctx = ref(null)
const showControls = ref(false)
const markedText = ref("Sure, asdf! Here are 5 example sentences using 評価する:\n" +
"\n" +
"1. <span class=\"clickable\" data-lang=\"Japanese\">彼の仕事を評価するのは難しいです。</span> (It is difficult to evaluate his work.)  \n" +
"2. <span class=\"clickable\" data-lang=\"Japanese\">私はこのレストランを高く評価します。</span> (I highly review this restaurant.)  \n" +
"3. <span class=\"clickable\" data-lang=\"Japanese\">新しい映画を評価しましたか？</span> (Did you review the new movie?)  \n" +
"4. <span class=\"clickable\" data-lang=\"Japanese\">先生は私たちのプレゼンテーションを評価しました。</span> (The teacher reviewed our presentation.)  \n" +
"5. <span class=\"clickable\" data-lang=\"Japanese\">彼女の努力は高く評価されました。</span> (Her efforts were highly evaluated.)\n" +
"\n" +
"Let me know if you'd like to try making your own sentence!")

// Canvas-related methods
function startDrawing(event) {
  event.preventDefault() // Prevent scrolling
  isDrawing.value = true
  const rect = canvasRef.value.getBoundingClientRect()
  const clientX = event.touches ? event.touches[0].clientX : event.clientX
  const clientY = event.touches ? event.touches[0].clientY : event.clientY
  ctx.value.beginPath()
  ctx.value.moveTo(clientX - rect.left, clientY - rect.top)
}

function draw(event) {
  if (!isDrawing.value) return
  event.preventDefault() // Prevent scrolling
  const rect = canvasRef.value.getBoundingClientRect()
  const clientX = event.touches ? event.touches[0].clientX : event.clientX
  const clientY = event.touches ? event.touches[0].clientY : event.clientY
  ctx.value.lineTo(clientX - rect.left, clientY - rect.top)
  ctx.value.stroke()
}

function stopDrawing() {
  isDrawing.value = false
}

function clearCanvas() {
  if (ctx.value) {
    ctx.value.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height)
  }
  showControls.value = false
}

onMounted(() => {
  const canvas = canvasRef.value
  ctx.value = canvas.getContext('2d')
  ctx.value.lineWidth = 2
  ctx.value.strokeStyle = 'black'

  // Add touch event listeners
  canvas.addEventListener('touchstart', startDrawing)
  canvas.addEventListener('touchmove', draw)
  canvas.addEventListener('touchend', stopDrawing)
  canvas.addEventListener('touchcancel', stopDrawing)

  // Add mouse event listeners (already present in the template)
})

</script>
<template>
  <nice-header />
  <div class="d-flex flex-column" style="height: 100%;">
    <div class="">
      ok hi there! i am the 1.
    </div>
    <div class="flex-grow-1" style="overflow-y: scroll">
      canvas below
      <button @click="showControls = !showControls">Toggle Controls</button>
      <div v-html="marked(markedText)" />
      whatever
      <div class="menu" v-if="showControls">
        some stuff here <br>
        some stuff here <br>
        some stuff here <br>
        some stuff here <br>
        some stuff here <br>
        some stuff here <br>
        some stuff here <br>
        some stuff here <br>
      </div>
      <canvas id="canvas" width="500" height="500"
            ref="canvasRef"

            @mousedown="startDrawing"
            @mousemove="draw"
            @mouseup="stopDrawing"
            @mouseleave="stopDrawing"
      ></canvas><br>
      i am going to overflow.<br>
    </div>
    <div class="mt-auto">
      ok hi there! i am the 3.
    </div>
    <div class="mt-auto">
      ok hi there! i am the 4.
    </div>
  </div>
  <nice-footer />
</template>
<style scoped>
canvas {
  border: 1px solid black;
  touch-action: none; /* Prevent scrolling on touch devices */
}
.menu {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
    transform: translateX(-40%);
}
</style>
